module.exports = __webpack_public_path__ + "static/media/GPLAY.63cc62df.svg";